import React, { useEffect, useState } from "react";
import styles from "./Schedule.module.css";
import ScheduleModal from "./ScheduleModal";
import { useSearchParams } from "react-router-dom";

import proxy from "proxy";

const Schedule = () => {
    const [events, setEvents] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    const [searchParams] = useSearchParams();
    const uniqueProjectId = searchParams.get('project');

    // Fetch events from backend
    const fetchEvents = async () => {
        try {
            const response = await fetch(`${proxy}/api/schedule/${uniqueProjectId}`, {
                method: "GET",

            })

            const responseBody = await response.json();
            console.log("respnseBody:", responseBody)
            setEvents(responseBody.data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (uniqueProjectId) fetchEvents();
    }, [uniqueProjectId]);

    const handleDelete = async (id) => {
        try {
            await fetch(`${proxy}/api/schedule/${id}`, {
                method: "DELETE",
            });

            // remove from UI instantly (no refetch needed)
            setEvents((prev) => prev.filter((event) => event._id !== id));
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className={styles.container}>

            <button
                className={styles.addBtn}
                onClick={() => setIsOpen(true)}
            >
                + Add Event
            </button>

            <div className={styles.eventList}>
                {events.length === 0 ? (
                    <p>No events</p>
                ) : (
                    events.map((event) => (
                        <div key={event._id} className={styles.eventCard}>
                            <p>
                                <strong>Date:</strong>{" "}
                                {new Date(event.dateTime).toLocaleDateString()}
                            </p>

                            <p>
                                <strong>Time:</strong>{" "}
                                {new Date(event.dateTime).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                })}
                            </p>
                            <p><strong>Event:</strong> {event.title}</p>

                            <button
                                className={styles.deleteBtn}
                                onClick={() => handleDelete(event._id)}
                            >
                                Delete
                            </button>
                        </div>
                    ))
                )}
            </div>

            {isOpen && (
                <ScheduleModal
                    projectId={uniqueProjectId}
                    onClose={() => setIsOpen(false)}
                    setEvents={setEvents}
                />
            )}
        </div>
    );
};

export default Schedule;